// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n[data-v-7202ed30]:export {\n  menuBg: #101820;\n  menuText: #8a97bb;\n  menuActiveText: #e48f93;\n  menuActiveBg: #934054;\n}\n\n/* Mixins */\n.form-block[data-v-7202ed30] {\n  width: 90%;\n}\n@media (min-width: 1024px) {\n.form-block .el-form[data-v-7202ed30] {\n    width: 80%;\n}\n}\n.form-block .el-steps--simple[data-v-7202ed30] {\n  padding: 13px 2%;\n}\n.form-block .el-step__description[data-v-7202ed30] {\n  padding: 5%;\n}", ""]);
// Exports
module.exports = exports;
